module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/icon_day2-0d1588a9fb287c9d3be94cc4ce409113.svg";